import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class DecoratorService {
  private static toastr: ToastrService;

  constructor(toastr: ToastrService) {
    DecoratorService.toastr = toastr;
  }

  static getToastr(): ToastrService {
    return this.toastr;
  }
} 